module.exports = __webpack_public_path__ + "img/9791156331759.392f31f3.jpg";